import { http } from '@/http/axios.js'

// 管理员列表
export function getPosBindPageAPI(params) {
  return http({
    url: `/api/admin/sft/official/pos-bind/page`,
    method: 'get',
    params
  })
}

export function importPosBindApi(data, agent_id) {
  return http({
    url: `/api/admin/sft/official/pos-bind/import?agent_id=` + agent_id,
    method: 'post',
    data
  })
}



export function getPosServiceFeePageAPI(params) {
  return http({
    url: `/api/admin/sft/official/pos-service-fee/page`,
    method: 'get',
    params
  })
}

export function importServiceFeeApi(data, agent_id) {
  return http({
    url: `/api/admin/sft/official/pos-service-fee/import?agent_id=` + agent_id,
    method: 'post',
    data
  })
}



export function getPosSettlementPageAPI(params) {
  return http({
    url: `/api/admin/sft/official/pos-settlement/page`,
    method: 'get',
    params
  })
}


export function importPosSettlementApi(data, agent_id) {
  return http({
    url: `/api/admin/sft/official/pos-settlement/import?agent_id=` + agent_id,
    method: 'post',
    data
  })
}


export function getPosWithdrawPageAPI(params) {
  return http({
    url: `/api/admin/sft/official/pos-withdraw/page`,
    method: 'get',
    params
  })
}


export function getPosSimYearFeePageApi(params) {
  return http({
    url: `/api/admin/sft/official/sim-year-fee/page`,
    method: 'get',
    params
  })
}


export function importSimYearFeeApi(data, agent_id) {
  return http({
    url: `/api/admin/sft/official/sim-year-fee/import?agent_id=`+ agent_id,
    method: 'post',
    data
  })
}
